<ol class="breadcrumb">
    <breadcrumbs></breadcrumbs>
</ol>
<div class="container-fluid">
    <div class="row">
        <div class="col-sm-12">
            <div class="card">
                <div class="card-header">
                    {{ 'admin.report_management' | transloco }}
                </div>
                <div class="card-body">
                    <div class="card">
                        <div class="card-header">
                            <div class="form-group row">
                                <label class="col-md-1 form-control-label">{{ 'admin.report_name' | transloco }}</label>
                                <div class="col-md-1">
                                    <select class="form-control" [(ngModel)]="name">
                                        <option *ngFor="let item of reports" [ngValue]="item.name"> {{item.name}}</option>
                                    </select>
                                </div>
                                <div class="col-md-2">
                                    <input type="text" [(ngModel)]="name" class="form-control" [placeholder]="'admin.report_name' | transloco">
                                </div>
                                <div class="col-md-2">
                                    <button (click)="displayReport()" class="btn btn-info btn-block">{{ 'admin.display' | transloco }}</button>
                                </div>
                                <div class="col-md-2">
                                    <button (click)="editReport()" class="btn btn-primary btn-block">{{ 'common.edit' | transloco }}</button>
                                </div>
                                <div class="col-md-2">
                                    <button (click)="saveReport()" class="btn btn-success btn-block">{{ 'common.save' | transloco }}</button>
                                </div>
                                <div class="col-md-2">
                                    <button (click)="confirmRemoveReport()" class="btn btn-danger btn-block">{{ 'common.delete' | transloco }}</button>
                                </div>
                            </div>
                        </div>
                        <div class="card-body">
                            <div id="designerContent"></div>
                            <div id="viewerContent"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<cb-modal-confirm #removeReportPopup (onConfirm)="removeReport()" [modalClass]="'modal-danger'" [closeButton]="'common.cancel' | transloco" [confirmButton]="'common.delete' | transloco" [title]="'common.delete' | transloco" [content]="'admin.confirm_delete_named' | transloco: {name: name}"></cb-modal-confirm>
